<template>
  <div>
    <b-table
      :items="filteredProducts"
      :fields="fields"
      small
      stacked="isStacked"
      sticky-header="true"
      :responsive="isResponsive"
      :tbody-tr-class="rowClass"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(images)="data">
        <img
          v-if="
            data.item.imgURLS &&
              Array.isArray(data.item.imgURLS) &&
              data.item.imgURLS[0].url
          "
          :src="data.item.imgURLS[0].url"
          :alt="data.item.name"
          style="height: 100px;"
        />
        <image-upload
          v-else
          ref="image-upload"
          :img-upload-idx="data.index"
          img-upload-type="product"
          :storage-path="productStoragePath"
          :max-image="1"
          :show-edit="true"
          :show-delete="true"
          @img-uploaded-url="handleImgUploadedURL"
        />
        <img
          v-if="false"
          src="@/assets/resourceBlocks/defaultProduct.jpg"
          :alt="data.item.name"
          style="height: 100px;"
        />
      </template>
      <template #cell(descriptionEditor)="data">
        <tip-tap-output
          v-if="data.item.description"
          :content="data.item.description"
          :show-less-char="100"
          :use-dots="true"
        />
      </template>
      <template #cell(actions)="data">
        <b-link
          size="sm"
          @click="handleEditProductClick(data.item)"
          class="mt-2"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
              fill="#B3C2CB"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
              fill="#B3C2CB"
            />
          </svg>
        </b-link>
        <b-link
          size="sm"
          class="mt-2"
          @click="handleDeleteProductClick(data.item)"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
              fill="#FF8C7D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
              fill="#FF8C7D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
              fill="#FF8C7D"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
              fill="#FF8C7D"
            />
          </svg>
        </b-link>
      </template>
      <template #cell(activeStatus)="data">
        <label class="toggle" :value="toggle.name">
          <div class="toggler" :class="[toggle.value ? 'bg' : '']">
            <div class="slider" :class="[toggle.value ? 'btns' : '']"></div>
          </div>
          <input
            type="checkbox"
            class="invisible"
            @change="handleActiveToggleChange(data.item, data.item.isActive)"
            v-model="data.item.isActive"
          />
        </label>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TipTapOutput from "@/components/common/tipTapOutput";
import ImageUpload from "@/components/common/imageUpload";
export default {
  name: "SectionProducts",
  components: {
    ImageUpload,
    TipTapOutput
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isResponsive: true,
      isStacked: false,
      productStoragePath: "rb_shop_product_img",
      fields: [
        /*{ key: 'index', label: 'Index', sortable: true },*/
        {
          key: "images",
          label: "Product",
          sortable: false,
          thStyle: { width: "10%" }
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          thStyle: { width: "20%" }
        },
        { key: "summary", label: "Summary", thStyle: { width: "20%" } },
        {
          key: "descriptionEditor",
          label: "Description",
          thStyle: { width: "50%" }
        },
        { key: "sku", label: "SKU", thStyle: { width: "3%" }, sortable: true },
        {
          key: "isbn",
          label: "ISBN",
          thStyle: { width: "3%" },
          sortable: true
        },
        {
          key: "price",
          label: "Price",
          thStyle: { width: "3%" },
          sortable: true
        },
        { key: "actions", label: "Actions", thStyle: { width: "3%" } },
        {
          key: "activeStatus",
          label: "Active",
          thStyle: { width: "3%" },
          sortable: true
        }
      ],
      toggle: {
        name: "Active",
        type: "btns",
        text: "Enable if you want the resource to be active in your corner",
        value: false
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    toolsFromPublishing() {
      return this.publishing &&
        this.publishing.tools &&
        Array.isArray(this.publishing.tools)
        ? this.publishing.tools
        : [];
    },
    thisTool() {
      return this.toolsFromPublishing.filter(aTool => {
        return aTool.toolId === this.resource.toolId;
      })[0];
    },
    settings() {
      return this.thisTool && this.thisTool.data && this.thisTool.data.settings
        ? this.thisTool.data.settings
        : null;
    },
    products() {
      return this.settings &&
        this.settings.products &&
        Array.isArray(this.settings.products)
        ? this.settings.products
        : [];
    },
    filteredProducts() {
      return this.products && Array.isArray(this.products)
        ? this.products.filter(aProduct => {
            return !aProduct.hasOwnProperty("_deleted_at");
          })
        : [];
    }
  },
  methods: {
    handleImgUploadedURL(idx, url) {
      const payload = {
        url: url,
        pos: 0
      };
      const product = this.products[idx];

      this.$emit(
        "add-img-to-product",
        "imgURLS",
        payload,
        "products",
        product.id
      );
    },
    handleEditProductClick(product) {
      this.$emit("edit-product", product);
    },
    handleDeleteProductClick(product) {
      this.$emit("delete-product", product);
    },
    handleActiveToggleChange(change) {
      this.$emit("toggle-isActive", this.product, change);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "awesome") return "table-success";
    }
  }
};
</script>

<style lang="scss" scoped>
.td-small {
  max-width: 10px;
}
.toggle {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .toggle-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
